
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Rögzítés',
	'find_label': 'Keresés',
	'findCancelLabel': 'Mégse',
	'dataPaneLabel': 'Adatok',
	'sourcePaneLabel': 'Kiválasztott források',
	'sourcePaneContentLabel': 'Forrás kiválasztása',
	'emptySourcePaneTitle': 'Forrás kiválasztása',
	'emptySourcePaneCaption': 'Kattintson az Forrás kiválasztása elemre egy műszerfal összeállításához a használt adatok hozzáadásával.',
	'addDataSource': 'Forrás kiválasztása',
	'addDataDashboardCoachMarkContents': 'Húzzon át adatokat az adatpanelről a műszerfalra.',
	'addDataStoryCoachMarkContents': 'Húzzon át adatokat az adatpanelről a történetre.',
	'addDataCoachMarkTitle': 'Adatok hozzáadása',
	'selectSourcesText': 'Válasszon ki és adjon hozzá egy adatforrást a(z) %{app} összeállításához.',
	'selectSourcesLabel': 'Forrás kiválasztása',
	'dataPreparationTitle': 'Az adatok előkészítése',
	'dataPreparationCaption': 'Az adatok előkészítésének befejezésekor itt jelennek meg az adatok.',
	'dataPreparationProgress': '%{percentage}% előkészítve ...',
	'dataPreparationSourceError': 'A(z) "%{sourceName}" adatelőkészítése sikertelen volt.',
	'dataPreparationStarted': 'A(z) "%{sourceName}" adatelőkészítése folyamatban van. A műszerfal szolgáltatásai az adatfeldolgozás befejeződésekor lesznek elérhetőek.',
	'dataPreparationComplete': 'A(z) "%{sourceName}" adatelőkészítése befejeződött. Most már használatra kész az összes műszerfal szolgáltatással.',
	'preparingData': 'Az adatok előkészítése...',
	'moserUnsupportedSourceType': 'Ez az adatforrástípus nem támogatott.',
	'errorSourcesTitle': 'Nem sikerült az adatfa betöltése',
	'errorLoadingDataSources': 'Hiba történt az adathalmazok listájának betöltése során',
	'errorLoadingDataTree': 'Hiba történt a fa betöltése során',
	'dataSetPaneLastUpdated': 'Legutóbbi frissítés: %{date}',
	'dataSourcePaneDateUnknown': 'Ismeretlen',
	'moreTitle': 'Továbbiak',
	'backLabel': 'Vissza',
	'addDataSourceDialogTitle': 'Forrás kiválasztása',
	'addDataSourceDialogButtonLabel': 'Hozzáadás',
	'dlg_use': 'Használat',
	'dlg_RelinkDataSourceTitle': 'A(z) "%{dataSourceName}" adathalmaz cseréje a következőre ...',
	'propertiesDialogTitle': 'Tulajdonságok',
	'missingDataSetData': 'Az adathalmazhoz tartozó adatok nem érhetők el. Frissítse az adathalmazt, vagy lépjen kapcsolatba az adminisztrátorral a forráshoz való hozzáférésért.',
	'errorMessageTitle': 'Hiba',
	'calculation_navigation_in_use': 'A számítások, szűrők vagy a navigációs útvonalak törlése az összes olyan megjelenítést érvényteleníti, amely a törölt elemre mutat. Biztosan elvégzi a törlést?',
	'delete_confirm': 'Törlés megerősítése',
	'previewUnavailable': 'Az adattálca és a globális szűrők nem érhetők el ehhez a csomagtípushoz.',
	'contextualGridTabName': 'Megjelenítési adatok',
	'DATA_TRAY_no_data_text': 'Jelenleg nincs semmilyen adat',
	'contextualGridMenuLabel': 'Megjelenítési adatok menü',
	'contextualGridExport': 'Exportálás',
	'nullValueText': 'Null',
	'relationships_title': 'Viszonyok',
	'forecastDetailsTabName': 'Statisztikai részletek előrejelzése',
	'forecastDetailsModelLabel': 'Modell',
	'forecastDetailsQualityMetricLabel': 'Pontossági intézkedések',
	'forecastDetailsSmoothingCoefLabel': 'Paraméterek',
	'forecastDetailsDiagnostics': 'Diagnosztika',
	'forecastDetailsForecastLabel': 'Előrejelzés',
	'forecastDetailsStatusLabel': 'Állapot',
	'forecastDetailsAccuracyPercentLabel': 'Pontosság %',
	'forecastDetailsTrendLabel': 'Trend',
	'forecastDetailsSeasonLabel': 'Szezonalitás',
	'forecastDetailsSeasonalPeriodLabel': 'Szezonális időszak',
	'forecastDetailsAlphaLabel': 'Alpha',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'Hiányzó szám',
	'forecastDetailsSeriesLengthLabel': 'Adatsor hossza',
	'forecastDetailsIgnoredPeriods': 'Figyelmen kívül hagyott időszakok',
	'forecastDetailsTrendStrength': 'Trend erőssége',
	'forecastDetailsSeasonalityStrength': 'Szezonalitás erőssége',
	'forecastDetailsTimeDeltaUnit': 'Dátum / idő tartomány',
	'forecastDetailsNotes': 'Megjegyzések',
	'DatasetRefresh_AmbiguousConnection': ' Az „Adatkészlet szerkesztése" használata a következő csatlakozási probléma megoldásához: %{errorMessage}'
});
